module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAAH6ji2bAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAR9JREFUeNpiYAACibqd70E0E5QhwIAOAAIIDhiBSv6jiAAEEBwgyzBhUwAQQDBVeIzHY8sEbEY5YLNoP0AA4XUaMmBCU9SAy0FMBB0DMWA/isIXTe4fcBi4kBGL7n4gZQDEjUCsAMTzgQYwAgQQuqL3xLpRgFiFDAQVwiINVxDhSRVgAAqFRqBnJhAVK0Dx9cS6MYBozzASUgC0NgFIPWDBkXoSQZJAXA/EF4CeWQAQYIwE0vh7aBpgJDm80QGehESegeQCRsIlBF7wAegTQaJiBZrU6qFcUOppIBBz84HYkZFAFP8nNlJghlIzDEHJh4GFUBiRYCAoeDYwEOGVAqh3cHoVFDTQIoiBqAQLKn2BVD4oE6JJgVw0ERjGB2ACALdcZHuf+vBIAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/icon/follow.png
// module id = OTYs
// module chunks = 1